import React, { useEffect } from "react";
import CommonHero from "../components/common/CommonHero";
import TermsImage from "../../src/assets/img/terms-img.webp"
import Conditions from "../components/terms-of-conditions/Conditions";

const TermsOfUsePage = () => {
   useEffect(() => {
        document.getElementById("title-page").innerHTML =
          "TripNest | Terms of use";
      }, []);
  return (
    <div>
      <CommonHero text={"Terms of Conditions"} imgUrl={TermsImage} />
      <Conditions/>
    </div>
  );
};

export default TermsOfUsePage;
